import atypes from '../actions/actionTypes';
import { errorTemplate, getError } from './utils';
import * as _ from 'lodash';

const _template = {
    error: errorTemplate(),
    userdata: {},
    isLoading: true,
    tenantCreationOpError: errorTemplate(),
    isTenantCreationFailed: false,
    tenantInfo: {},  // template space for tenant info, it may be override other call
    locations: [],
    clusterLocations: [],
    numOfRetried: 0,
    tokenRenewed: '',
};

function newState() {
    return {
        ..._.cloneDeep(_template)
    }
}

export default function(state = newState(), action) {
    switch (action.type) {
        case atypes.LOAD_USER_DATA_REQUEST:
        case atypes.LOAD_OCI_INSTANCES_REQUEST: {
            return {
                ...state,
                isLoading: true,
                error: errorTemplate(),
            }
        }
        case atypes.LOAD_USER_DATA_SUCCESS: {
            return {
                ...state,
                userdata: action.payload || {},
                isLoading: false,
            }
        }
        case atypes.LOAD_USER_DATA_FAILURE:
        case atypes.LOAD_OCI_INSTANCES_FAILURE: {
            const defaultMsg = action.type === atypes.LOAD_USER_DATA_FAILURE ? 'user' : 'tenant';
            return {
                ...state,
                error: getError(action.payload, 'Failed to load ' + defaultMsg + ' information.'),
                isLoading: false,
            }
        }
        case atypes.LOAD_OCI_INSTANCES_SUCCESS: {
            return {
                ...state,
                instances: action.payload || [],
                isLoading: false,
            }
        }
        case atypes.GET_TENANT_STATUS_REQUEST: {
            return {
                ...state,
                error: errorTemplate(),
            }
        }
        case atypes.GET_TENANT_STATUS_SUCCESS: {
            return {
                ...state,
                tenantInfo: action.payload || {},
                isLoading: false,
            }
        }
        case atypes.GET_TENANT_STATUS_FAILURE: {
            return {
                ...state,
                tenantInfo: {},
                error: getError(action.payload, 'Failed to get tenant information'),
                isLoading: false,
            }
        }
        case atypes.CREATE_OCI_INSTANCES_REQUEST: {
            return {
                ...state,
                tenantInfo: {},
                isTenantCreationFailed: false,
                tenantCreationOpError: errorTemplate(),
            }
        }
        case atypes.CREATE_OCI_INSTANCES_SUCCESS: {
            return {
                ...state,
                tenantInfo: action.payload || {},
                isTenantCreationFailed: false,
                tenantCreationOpError: errorTemplate(),
                isLoading: false,
            }
        }
        case atypes.CREATE_OCI_INSTANCES_FAILURE: {
            return {
                ...state,
                isTenantCreationFailed: true,
                tenantCreationOpError: getError(action.payload, 'Failed to create tenant.'),
                tenantInfo: {},
                isLoading: false,
            }
        }
        case atypes.UPDATE_OCI_INSTANCES_REQUEST: {
            return {
                ...state,
                error: errorTemplate(),
                isLoading: true,
            }
        }
        case atypes.UPDATE_OCI_INSTANCES_SUCCESS: {
            return {
                ...state,
                instances: _.isNil(action.payload) ? [] : [ action.payload ],
                isLoading: false,
            }
        }
        case atypes.UPDATE_OCI_INSTANCES_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Failed to update tenant.'),
                isLoading: false,
            }
        }
        case atypes.REMOVE_OCI_INSTANCES_REQUEST: {
            return {
                ...state,
                error: errorTemplate(),
                isLoading: true,
            }
        }
        case atypes.REMOVE_OCI_INSTANCES_SUCCESS: {
            return {
                ...state,
                instances: action.payload || {},
                isLoading: false,
            }
        }
        case atypes.REMOVE_OCI_INSTANCES_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Failed to remove tenant.'),
                isLoading: false,
            }
        }
        case atypes.CREATE_OCI_USER_TOKEN_REQUEST:
        case atypes.CREATE_OCI_USER_TOKEN_SUCCESS:{
            return {
                ...state,
                ociAuthorized: action.payload || {},
                error: errorTemplate(),
                isLoading: false,
            }
        }
        case atypes.SECURITY_INVALID_DOMAIN:
        case atypes.CREATE_OCI_USER_TOKEN_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Unauthorized'),
                isLoading: false,
            }
        }
        case atypes.CLEAR_OCI_ERROR: {
            return {
                ...state,
                error: errorTemplate(),
            }
        }
        case atypes.LOAD_CLUSTER_LOCATIONS_REQUEST: {
            return {
                ...state,
                clusterLocations: [],
            }
        }
        case atypes.LOAD_CLUSTER_LOCATIONS_SUCCESS: {
            return {
                ...state,
                clusterLocations: action.locations || [],
            }
        }
        case atypes.LOAD_CLUSTER_LOCATIONS_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Failed to load Data Infrastructure Insights cluster location.'),
            }
        }
        case atypes.LOAD_USER_AND_LOCATIONS_REQUEST: {
            return {
                ...state,
                error: errorTemplate(),
                isLoading: true,
            }
        }
        case atypes.LOAD_USER_AND_LOCATIONS_SUCCESS: {
            return {
                ...state,
                userdata: action.userData || {},
                clusterLocations: action.locations || [],
                error: errorTemplate(),
                isLoading: false,
            }
        }
        case atypes.LOAD_USER_AND_LOCATIONS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: getError(action.payload, 'Failed to load Data Infrastructure Insights information.'),
            }
        }
        case atypes.RENEW_TOKENS_REQUEST: {
            return {
                ...state,
                error: errorTemplate(),
                numOfRetried: 0,
                isLoading: true,
                tokenRenewed: '',
            }
        }
        case atypes.RENEW_TOKENS_SUCCESS: {
            return {
                ...state,
                error: errorTemplate(),
                numOfRetried: 0,
                isLoading: false,
                tokenRenewed: 'success',
            }
        }
        case atypes.RENEW_TOKENS_RETRY: {
            return {
                ...state,
                error: errorTemplate(),
                numOfRetried: action.payload,
                isLoading: true,
                tokenRenewed: '',
            }
        }
        case atypes.RENEW_TOKENS_FAILURE: {
            return {
                ...state,
                error: getError(action.payload, 'Access Denied'),
                numOfRetried: 0,
                isLoading: false,
                tokenRenewed: 'failure',
            }
        }
        default:
            return state;

    }
}
